export default "__VITE_ASSET__u6g4pE3i__$_?component__"